import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '../tools/withStyles';
import { Main } from '../components/Main';
import { Secuence } from '../components/Secuence';
import { Text } from '../components/Text';
import { Fader } from '../components/Fader';
import { withPrefix } from 'gatsby';

import { Link } from '../components/Link';

const questions = [
  {
    q: '¿Dónde será el concierto en Costa Rica?',
    a: 'En el Palacio de los Deportes, Calle 12, Heredia, Costa Rica.'
  },
  {
    q: '¿A qué hora abren las puertas?',
    a: 'A las 12 del mediodía. Conviene llegar antes para entrar con calma.'
  },
  {
    q: '¿Cuándo salen a la venta las entradas?',
    a: 'La preventa Fase 1 ya está activa en omticket.com. Al agotarse, pasa a la Fase 2 con precios nuevos.'
  },
  {
    q: '¿Hay restricción de edad?',
    a: 'Es apto para todo público. Los menores ingresan con un adulto responsable.'
  }
];

const styles = theme => ({
  root: {},
  place: {
    marginTop: 8,
    fontFamily: theme.typography.primary,
    color: theme.color.secondary.main
  },
  note: {
    maxWidth: 680
  },
  photo: {
    display: 'block',
    width: '100%',
    maxWidth: 760,
    height: 280,
    objectFit: 'cover',
    objectPosition: 'center 70%',
    margin: [8, 0, 16]
  },
  portrait: {
    display: 'block',
    width: '100%',
    maxWidth: 420,
    margin: [8, 0, 16]
  },
  question: {
    marginBottom: 16
  }
});

class Concierto extends React.Component {
  static propTypes = {
    classes: PropTypes.object
  };

  render () {
    const { classes } = this.props;

    return (
      <Main className={classes.root}>
        <Secuence stagger>
          <h1><Text>La noche del 21 de noviembre</Text></h1>
          <Fader>
            <img
              className={classes.portrait}
              src={withPrefix('/images/hero-yoko.webp')}
              alt='Yoko Takahashi, retrato del afiche oficial de la gira New Genesis'
            />
            <img
              className={classes.photo}
              src={withPrefix('/images/palacio.jpg')}
              alt='Vista del Palacio de los Deportes en Heredia'
            />
            <p className={classes.place}>Palacio de los Deportes</p>
            <p>Calle 12 · Heredia, Costa Rica</p>
          </Fader>
          <p className={classes.note}>
            <Text>Portal Pop Culture estrena su primer concierto en Costa Rica con Yoko Takahashi y la gira New Genesis. Una noche para escuchar en vivo la voz de A Cruel Angel’s Thesis.</Text>
          </p>
          <p className={classes.note}>
            <Fader>Las puertas abren a las 12 del mediodía. Llegá con tiempo para entrar sin afán. El evento es apto para todo público y los menores ingresan con un adulto responsable.</Fader>
          </p>
          <h2><Text>Antes de ir</Text></h2>
          <Fader>
            {questions.map(item => (
              <div key={item.q} className={classes.question}>
                <h3>{item.q}</h3>
                <p>{item.a}</p>
              </div>
            ))}
          </Fader>
          <p>
            <Fader>
              Consultas: <Link href='mailto:contacto@portalpopculture.com' target='correo'>contacto@portalpopculture.com</Link>
              {' · '}
              <Link href='https://wa.me/50672384375' target='whatsapp'>+506 7238 4375</Link>
            </Fader>
          </p>
        </Secuence>
      </Main>
    );
  }
}

export default withStyles(styles)(Concierto);
